// extracted by css-extract-rspack-plugin
export default {"link":"SimpleEntityWidget_link__hv6Bp"};